export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** Returns a validation result for a likely valid email address. */
export function isValidEmail(value) {
    const trimmed = value.trim();
    if (trimmed.length === 0) {
        return { ok: false, reason: "Email address is required." };
    }
    if (!EMAIL_REGEX.test(trimmed)) {
        return { ok: false, reason: "Email address must be in the format local@domain.tld." };
    }
    return { ok: true, value: trimmed };
}
/** Trims whitespace and lowercases an email address for storage or comparison. */
export function normalizeEmail(value) {
    return value.trim().toLowerCase();
}
